export default __webpack_public_path__ + "static/media/sowmz-lamp.6634aa14.jpg";